import script from "./Collage.vue?vue&type=script&setup=true&lang=js"
export * from "./Collage.vue?vue&type=script&setup=true&lang=js"

import "./Collage.vue?vue&type=style&index=0&id=799dca9a&scoped=true&lang=css"
import "./Collage.vue?vue&type=style&index=1&id=799dca9a&lang=css"

import exportComponent from "/home/runner/work/HexaHome/HexaHome/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.45_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799dca9a"]])

export default __exports__